// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState } from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/container/index.async';
import CarouselContainer from '@tcp/core/src/components/common/molecules/Carousel/container/Carousel.container';
import { getIconPath, getViewportInfo, isClient } from '@tcp/core/src/utils';
import { capitalizeWords } from '@tcp/core/src/utils/utils';
import DyRecommendationTile from '@tcp/core/src/components/common/molecules/DyRecommendations/views/DyRecommendationTile.view';
import style from '@tcp/core/src/components/common/molecules/RecommendationCarousel/styles/RecommendationCarousel.style';
import config from '../config';

const renderHeader = ({ headerLabel, fromOrderDetails }) => {
  return (
    <BodyCopy
      className={!fromOrderDetails ? 'recommendations-header-new' : ''}
      fontSize="fs16"
      component="div"
      fontFamily="secondary"
      fontWeight="bold"
      dataLocator="dy_header_label_text"
      id="recommendation"
    >
      {headerLabel}
    </BodyCopy>
  );
};

const renderSubHeader = ({ subHeaderLabel }) => {
  return (
    <BodyCopy
      fontSize="fs14"
      component="div"
      fontFamily="secondary"
      fontWeight="regular"
      className="elem-mt-XXS elem-mb-MED "
      id="recommendation"
    >
      {subHeaderLabel}
    </BodyCopy>
  );
};

const renderAccordionHeader = ({
  headerLabel,
  handleAccordionToggle,
  accordionOpenClass,
  isAccordionOpen,
  isDesktop,
}) => {
  if (!isDesktop) {
    return (
      <button
        className={`accordion-header-new ${accordionOpenClass}`}
        fontSize="fs16"
        component="div"
        fontFamily="secondary"
        fontWeight="bold"
        onClick={handleAccordionToggle}
        id="recommendation"
        aria-expanded={isAccordionOpen}
        aria-controls="recommendation-product-section"
      >
        {headerLabel}
      </button>
    );
  }
  return (
    <BodyCopy
      className={`accordion-header-new`}
      fontSize="fs16"
      component="div"
      fontFamily="secondary"
      fontWeight="bold"
      id="recommendation"
    >
      {headerLabel}
    </BodyCopy>
  );
};

const renderRecommendations = ({
  products,
  isHideOriginalPriceAndMarchantTagEnabled,
  headerLabel,
  page,
  currencySymbol,
  currencyAttributes,
  onQuickViewOpenClick,
  isAddedToBag,
  isBackToQuickviewCTAEnabled,
  isQvModalOpen,
  closeQvModal,
  serverTime,
  promotionsData,
  isPromoMsgEnabledRecommendation,
  isDynamicBadgeEnabledAbtest,
  isTransparentImageSizeReduceEnabled,
  isBagPage,
  bagItemCount,
  spcBag,
  recommendationSelector,
  sendTrackEventsToDy,
}) => {
  const nonEmptyBag = bagItemCount > 0;
  return products?.map((product, index) => {
    const productId = product.generalProductId;
    return (
      <DyRecommendationTile
        key={productId}
        product={product}
        isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
        headerLabel={headerLabel}
        page={page}
        currencySymbol={currencySymbol}
        currencyAttributes={currencyAttributes}
        onQuickViewOpenClick={onQuickViewOpenClick}
        isAddedToBag={isAddedToBag}
        isBackToQuickviewCTAEnabled={isBackToQuickviewCTAEnabled}
        isQvModalOpen={isQvModalOpen}
        closeQvModal={closeQvModal}
        promotionsData={promotionsData}
        serverTime={serverTime}
        isBagPage={isBagPage}
        isPromoMsgEnabledRecommendation={isPromoMsgEnabledRecommendation}
        isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
        isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
        bagItemCount={nonEmptyBag}
        spcBag={spcBag}
        recommendationSelector={recommendationSelector}
        sendTrackEventsToDy={sendTrackEventsToDy}
        index={index}
        totalProductsCount={products?.length || 0}
      />
    );
  });
};

const renderRecommendationList = ({
  products,
  isHideOriginalPriceAndMarchantTagEnabled,
  headerLabel,
  page,
  currencySymbol,
  currencyAttributes,
  onQuickViewOpenClick,
  isAddedToBag,
  showSkeletonWithLazyLoad,
  isBackToQuickviewCTAEnabled,
  isQvModalOpen,
  closeQvModal,
  serverTime,
  promotionsData,
  isPromoMsgEnabledRecommendation,
  isDynamicBadgeEnabledAbtest,
  isTransparentImageSizeReduceEnabled,
  isBagPage,
  bagItemCount,
  spcBag,
  recommendationSelector,
  sendTrackEventsToDy,
}) => {
  const minProductsLength = isAddedToBag
    ? config.CAROUSEL_OPTIONS_ADDED_TO_BAG.slidesToShow
    : config.CAROUSEL_OPTIONS.slidesToShow;

  const isMobileOrTablet = isClient()
    ? getViewportInfo().isMobile || getViewportInfo().isTablet
    : null;

  const props = {
    products,
    isHideOriginalPriceAndMarchantTagEnabled,
    headerLabel,
    page,
    currencySymbol,
    currencyAttributes,
    onQuickViewOpenClick,
    isAddedToBag,
    isBackToQuickviewCTAEnabled,
    isQvModalOpen,
    closeQvModal,
    serverTime,
    promotionsData,
    isPromoMsgEnabledRecommendation,
    isDynamicBadgeEnabledAbtest,
    isTransparentImageSizeReduceEnabled,
    isBagPage,
    bagItemCount,
    spcBag,
    recommendationSelector,
    sendTrackEventsToDy,
  };
  const CarouselView = showSkeletonWithLazyLoad ? CarouselContainer : Carousel;
  if (isMobileOrTablet) {
    return <div className="scroll-container-mobile-tablet">{renderRecommendations(props)}</div>;
  }
  if (products?.length > minProductsLength) {
    return (
      <CarouselView
        className="recommendation-carousel-new"
        options={isAddedToBag ? config.CAROUSEL_OPTIONS_ADDED_TO_BAG : config.CAROUSEL_OPTIONS}
        carouselConfig={{
          customArrowLeft: getIconPath('icon-carrot-grey-large'),
          customArrowRight: getIconPath('icon-carrot-grey-large'),
          dataLocatorCarousel: `${headerLabel}-variation`,
        }}
        fromDyRecommendations
      >
        {renderRecommendations(props)}
      </CarouselView>
    );
  }

  return <div className="no-carousel-container-desktop">{renderRecommendations(props)}</div>;
};

const RecommendationCarousel = (props) => {
  const {
    className,
    isPdpPlaProducts,
    title,
    products,
    isHideOriginalPriceAndMarchantTagEnabled,
    accordionHeader,
    page,
    currencySymbol,
    currencyAttributes,
    onQuickViewOpenClick,
    isPDP,
    isHomePage,
    isAddedToBag,
    isBackToQuickviewCTAEnabled,
    isQvModalOpen,
    closeQvModal,
    fromOrderDetails,
    subHeaderLabel,
    serverTime,
    promotionsData,
    isPromoMsgEnabledRecommendation,
    isDynamicBadgeEnabledAbtest,
    isTransparentImageSizeReduceEnabled,
    isBIACombinedCarouselEnabled,
    fromBIA,
    isBagPage,
    bagItemCount,
    spcBag,
    recommendationSelector,
    sendTrackEventsToDy,
  } = props;
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const showSkeletonWithLazyLoad = isPDP || isBagPage || isHomePage;
  const handleAccordionToggle = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  const accordionOpenClass = !isAccordionOpen ? 'hide-recommendations' : '';

  const headerLabelCapitalized = typeof title === 'string' ? capitalizeWords(title) : '';
  const { isMobile, isDesktop } = getViewportInfo() || {};

  return (
    <div className={`recommendation-main-container-new ${className}`}>
      <section
        className="recommendations-tile-new"
        aria-roledescription="carousel"
        aria-label={`${headerLabelCapitalized} product recommendations`}
      >
        {products?.length > 0 && (
          <Row className="recommendations-wrapper">
            <div>
              {!accordionHeader &&
                !isBIACombinedCarouselEnabled &&
                !fromBIA &&
                renderHeader({ headerLabel: headerLabelCapitalized, fromOrderDetails })}
              {fromOrderDetails && renderSubHeader({ subHeaderLabel })}
            </div>
            {accordionHeader &&
              renderAccordionHeader({
                headerLabel: headerLabelCapitalized,
                handleAccordionToggle,
                accordionOpenClass,
                isPdpPlaProducts,
                isAccordionOpen,
                isDesktop,
              })}
            <div
              className="recommendation-product-section"
              aria-label={`${products?.length || 0} recommended products`}
            >
              {renderRecommendationList({
                products,
                isHideOriginalPriceAndMarchantTagEnabled,
                headerLabel: headerLabelCapitalized,
                page,
                currencySymbol,
                currencyAttributes,
                onQuickViewOpenClick,
                showSkeletonWithLazyLoad,
                isAddedToBag,
                isBackToQuickviewCTAEnabled,
                isQvModalOpen,
                closeQvModal,
                serverTime,
                promotionsData,
                isPromoMsgEnabledRecommendation,
                isMobile,
                isDynamicBadgeEnabledAbtest,
                isTransparentImageSizeReduceEnabled,
                isBagPage,
                bagItemCount,
                spcBag,
                recommendationSelector,
                sendTrackEventsToDy,
              })}
            </div>
          </Row>
        )}
      </section>
    </div>
  );
};

export { RecommendationCarousel as RecommendationCarouselVanilla };

export default errorBoundary(withStyles(RecommendationCarousel, style));
